var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3553_40823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0002C12 11.6002 11.8 11.2002 11.6 11.0002L5 4.4002C4.4 3.80019 3.4 3.80019 2.8 4.40019C2.2 5.00019 2.2 6.00019 2.8 6.60019L8.2 12.0002L2.8 17.4002C2.2 18.0002 2.2 19.0002 2.8 19.6002C3.4 20.2002 4.4 20.2002 5 19.6002L11.4 13.2002C11.8 12.8002 12 12.4002 12 12.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3553_40823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    fill: "white",
    transform: "translate(12) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrowRight);
export default __webpack_public_path__ + "static/media/button_arrow_right.43f5c01b0dede5e5e96a0a2e315d96d2.svg";
export { ForwardRef as ReactComponent };